import React, { useState, useRef, PropsWithChildren } from "react";

import ReactDOM from "react-dom";
import styles from "ui/Tooltip/Tooltip.module.scss";
import { PlacementType } from "ui/Tooltip/Tooltip";
import { useStore } from "store";

import { cn } from "helpers/style";
import { useBreakpoint, useTooltipComputedStyles } from "helpers/hooks";
import innerStyles from "./CombinedTooltip.module.scss";
import ProductModal from "./components/ProductModal/ProductModal";

export type Props = {
  item: Entity.Product.BundleBadge;
  placement: PlacementType;
  tooltipContent: JSX.Element;
};

const CombinedTooltip: React.FC<PropsWithChildren<Props>> = ({
  placement = "top",
  tooltipContent,
  children,
  item,
}: PropsWithChildren<Props>) => {
  const width = 407;
  const breakpoint = useBreakpoint();
  const { notifications } = useStore();
  const [rect, setRect] = useState(null);
  const [open, toggle] = useState(false);
  const wrapper = useRef(null);
  const computedStyles = useTooltipComputedStyles({
    rect,
    placement,
    maxWidth: width,
  });

  function onClick() {
    if (["laptop", "desktop"].includes(breakpoint)) {
      setRect(wrapper.current.getBoundingClientRect());
      toggle(true);
    } else {
      notifications.show({
        type: "tooltip",
        component: ProductModal,
        props: {
          item,
        },
      });
    }
  }

  function onMouseLeave() {
    toggle(false);
  }

  return (
    <div
      className={cn([
        styles.tooltip,
        innerStyles.tooltipWrapper,
        open && styles.tooltipOpened,
      ])}
      ref={wrapper}
      onClick={onClick}
      onMouseLeave={onMouseLeave}
    >
      <>
        {children}
        {open &&
          ReactDOM.createPortal(
            <span className={styles.tooltipLabelWrapper} style={computedStyles}>
              <span
                className={cn([styles.tooltipLabel, innerStyles.label])}
                style={{
                  width,
                }}
              >
                {tooltipContent}
              </span>
            </span>,
            document.getElementById("tooltip-portal")
          )}
      </>
    </div>
  );
};

export default CombinedTooltip;
